import React, { useEffect } from "react";
import HomeContent from "../../components/home/content";
import RootLayout from "../layout";
import { updateAllLayouts } from "@noriginmedia/norigin-spatial-navigation";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../redux/Slices/loading.slice";
import PageLayout from "../../components/layout/PageLayout";
import { useShowcaseCacheWithConfig } from "../../utils/hooks/useShowcaseCache";

const SeriesHome = () => {
  const dispatch = useDispatch();

  const { data: homeData, loading } = useShowcaseCacheWithConfig({
    cacheKey: "series",
    configKey: "series",
    versionTitle: "serial",
  });

  // Handle loading state for sidebar
  useEffect(() => {
    if (loading) {
      dispatch(startLoading("در حال بارگذاری سریال‌ها..."));
    } else {
      dispatch(stopLoading());
      updateAllLayouts();
    }
  }, [loading, dispatch]);

  return (
    <RootLayout>
      <PageLayout loading={loading} skeletonType="showcase">
        {homeData && <HomeContent showCaseData={homeData} isShowcasePage={true} contentKind="series" />}
      </PageLayout>
    </RootLayout>
  );
};

export default SeriesHome;

